// src/components/sections/FinalCTA.js
import React from "react";

const FinalCTA = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center text-white bg-transparent min-h-[260px] sm:min-h-[300px] px-4 py-10">
      
      {/* Heading */}
      <div className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-medium mb-4 leading-tight">
        Empower Your Business with Our Fine Tuned Digital Solutions
      </div>

      {/* Subtitle */}
      <div className="font-medium text-base sm:text-lg md:text-xl py-4 sm:py-6 mb-4">
        Take the first step in creating a better tomorrow by joining hands with <br className="hidden sm:block" />
        Vivekasoftek
      </div>

      {/* Button */}
      <a href="/products#DemoForm">
        <button className="text-sm sm:text-md font-medium bg-white text-black px-6 sm:px-8 py-2.5 sm:py-3 rounded-full border-2 border-white hover:text-white hover:border-white hover:bg-transparent transition-all duration-300">
          Get Demo
        </button>
      </a>

    </div>
  );
};

export default FinalCTA;
